<template>
<div>
  <v-overlay :value="showOverlay" :z-index="10000000">
    <v-progress-circular color="#C4170C" indeterminate="indeterminate" size="64"></v-progress-circular>
  </v-overlay>
  <v-stepper class="pt-6 pr-6 pl-6" v-model="step" vertical="vertical">
    <v-stepper-step :step="1" :complete="step &gt; 1" color="#FF2B2D">{{ $t('selecione-servico-data') }}</v-stepper-step>
    <v-stepper-content :step="1">
      <v-form v-model="step_verified[step]">
        <div class="row">
          <div class="col-12 col-sm-12">
            <v-card class="py-4 px-6" hover="hover" min-height="265">
              <div class="row">
                <div class="col-12 col-sm-4 pb-0">
                  <v-autocomplete 
                    v-model="form.grupoId" 
                    :items="grupos.toArray()" 
                    item-text="nome" 
                    item-value="id" 
                    :rules="rules.grupoId" 
                    :no-data-text="$t('nenhum-grupo-encontrado')"     
                    :placeholder="`${$t('Grupo de Serviço')}*`" 
                    :hint="`*${$t('obrigatorio')}`" 
                    persistent-hint="persistent-hint"></v-autocomplete>
                </div>
                <div class="col-12 col-sm-4 pb-0">
                  <v-autocomplete 
                    v-model="form.servico_id" 
                    :items="servicos.toArray()" 
                    item-text="nome" 
                    item-value="id" 
                    :rules="rules.servico_id" 
                    :no-data-text="$t('nenhum-servico-encontrado')" 
                    :placeholder="`${$t('servico')}*`" 
                    :hint="`*${$t('obrigatorio')}`" 
                    persistent-hint="persistent-hint"></v-autocomplete>
                </div>
                <div class="col-12 col-sm-4 pb-0">
                  <v-autocomplete 
                    v-model="form.polo_id" 
                    :items="polos.toArray()" 
                    item-text="polo_nome" 
                    item-value="polo_id" 
                    :rules="rules.polo_id" 
                    :no-data-text="$t('nenhum-polo-encontrado')" 
                    :placeholder="`${$t('polo')}*`" 
                    :hint="`*${$t('obrigatorio')}`" 
                    persistent-hint="persistent-hint"></v-autocomplete>
                </div>
                <div class="col-12 col-sm-4 py-0">
                  <div class="row">
                    <div class="col-9 col-md-6">
                      <v-menu>
                        <template v-slot:activator="{ on }">
                          <v-text-field 
                            :label="`${$t('data')}*`" 
                            append-icon="date_range" 
                            :rules="rules.data" 
                            readonly="readonly" 
                            :value="data | moment('DD / MM / YYYY')" 
                            v-on="on" 
                            :hint="`*${$t('obrigatorio')}`" 
                            :disabled="!isDatePickerEnabled" 
                            persistent-hint="persistent-hint"></v-text-field>
                        </template>
                        <v-date-picker 
                          color="#C4170C" 
                          v-model="data" 
                          :min="minDate" 
                          :max="maxDate" 
                          :locale="locale_code" 
                          :allowed-dates="allowedDates" 
                          :picker-date.sync="pickerDate"></v-date-picker>
                      </v-menu>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-4 py-0">
                  <div class="row">
                    <div class="col-9 col-md-6">
                      <v-autocomplete 
                        v-model="hora" 
                        :items="horarios_disponiveis.toArray()" 
                        item-text="hora_local" 
                        item-value="hora_agendado" 
                        :rules="rules.hora" 
                        :no-data-text="$t('nenhum-horario-disponivel')" 
                        :placeholder="`${$t('horario')}*`" 
                        :hint="`*${$t('obrigatorio')}`" 
                        persistent-hint="persistent-hint"></v-autocomplete>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">             
                <v-col  v-if="informar_matricula_inscricao">
                  <v-row v-for="i in form.documentosImovel" :key="i">
                      <div class="col-12 col-sm-4 pb-0">
                        <v-select
                          v-model="i.opcaoImovel"
                          :items="opcoesImovel"
                          item-text="text"
                          item-value="value"
                          label="Selecione a opção de imóvel"
                        ></v-select>
                      </div>
                      <div class="col-12 col-sm-4 pb-0">
                        <v-text-field 
                          v-model="i[i.opcaoImovel]" 
                          :placeholder="`Inscrição ou matrícula`" 
                          :rules="rules.inscricao_matricula" 
                          :hint="`*${$t('obrigatorio')}`" 
                          persistent-hint="persistent-hint"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"> </v-text-field>
                      </div>
                      <v-col cols="1">
                        <v-btn fab x-small style="margin-top: 10px; important!" @click="removeField(i)">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-col>
                  </v-row>
                </v-col>
              </div>
              <div class="row">
               <v-col  class="col-12 col-lg-2 col-md-3 col-sm-4 pb-0" v-if="informar_matricula_inscricao">
                    <v-btn color="#C4170C" style="text-transform: none" :dark=true  @click="addFields">
                      Adicionar Imóvel
                    </v-btn>
                  </v-col>
                <v-col class="col-12 col-sm-8 pb-0" v-if="informar_matricula_inscricao">
                  <p style="margin-top: 8px; margin-left: 10px; important!">
                    <i>Neste agendamento, você tem um limite de 5 imóveis. Caso não possua o número de matrícula ou inscrição do imóvel entrar em contato com nossa Central de Atendimento pelo E-mail: contatosim@marica.rj.gov.br ou Whatsapp: +55 21 96810-2936.</i></p>
                </v-col>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 py-0">
                  <div class="row">
                    <div class="col-9 col-md-6">
                      <v-btn 
                        class="ml-2 mr-8 my-4" 
                        color="#C4170C" 
                        style="text-transform: none" 
                        :dark="step_verified[step]" 
                        :light="!step_verified[step]" 
                        :disabled="!step_verified[step]" 
                        @click="step++">{{ $t('proximo') }}</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </v-form>
    </v-stepper-content>
    <v-stepper-step :step="2" :complete="step &gt; 2" color="#FF2B2D">{{ $t('preencha-seus-dados') }}</v-stepper-step>
    <v-stepper-content :step="2">
      <v-form v-model="step_verified[step]">
        <div class="row">
          <div class="col-12 col-sm-12">
            <v-card class="py-4 px-6" hover="hover" min-height="265">
              <div class="row">
                <div class="col-12 col-sm-4">
                  <v-text-field 
                    :label="`${$t('nome')}*`" 
                    v-model="form.nome" 
                    :rules="rules.nome" 
                    :hint="`*${$t('obrigatorio')}`" 
                    persistent-hint="persistent-hint"></v-text-field>
                </div>
                <div class="col-12 col-sm-4">
                  <v-text-field 
                    :label="`${$t('celular')}*`" 
                    v-model="maskedCelular" 
                    :rules="rules.celular" 
                    max-length="15" 
                    :hint="`*${$t('obrigatorio')}`" 
                    persistent-hint="persistent-hint" 
                    @input.native="onInputCelular"></v-text-field>
                </div>
                <div class="col-12 col-sm-4">
                  <v-text-field 
                    :label="$t('email')" 
                    :rules="rules.email" 
                    v-model="form.email"></v-text-field>
                </div>
                <div class="col-12 col-sm-4">
                  <v-text-field 
                    :label="`${$t('cpf')}*`" 
                    :rules="rules.cpf" 
                    v-model="maskedCpf" 
                    :hint="`*${$t('obrigatorio')}`" 
                    persistent-hint="persistent-hint" 
                    @input.native="onInputCpf"></v-text-field>
                </div>
              </div>
              <v-btn 
                class="ml-2 mr-8 my-4" 
                color="#707070" 
                style="text-transform: none" 
                @click="step--" 
                dark="dark">{{ $t('anterior') }}</v-btn>
              <v-btn 
                class="ml-2 my-4" 
                color="#C4170C" 
                style="text-transform: none" 
                :dark="step_verified[step]" 
                :light="step_verified[step]" 
                :disabled="!step_verified[step]" 
                @click="submitAgendamento">{{ $t('agendar') }}</v-btn>
            </v-card>
          </div>
        </div>
      </v-form>
    </v-stepper-content>
  </v-stepper>
  <div class="row">
    <div class="col-12 pl-12">
      <v-btn 
        class="ml-2 my-4" 
        light="light" 
        color="#0000004D" 
        to="/" 
        style="text-transform: none">{{ $t('cancelar') }}</v-btn>
    </div>
  </div>
</div>
</template>

<script lnag="ts">
import { Vue, Component, Watch } from "vue-property-decorator";
import moment from "moment";
import collect from "collect.js";
import VMasker from "vanilla-masker";
import ServicoRepository from "@/repository/ServicoRepository";
import PoloRepository from "@/repository/PoloRepository";
import AgendamentoRepository from "@/repository/AgendamentoRepository";
import GrupoServicoRepository from "@/repository/GrupoServicoRepository";
import addressMixin from "../utils/mixins/address";

@Component({
  data: (vm) => ({
    step: 1,
    step_verified: [null, false, false],
    sendindForm: false,
    showOverlay: false,
    isDatePickerEnabled: false,
    notAllowedDates: [
      "2020-10-12",
      "2020-10-28",
      "2020-10-29",
      "2020-10-30",
      "2020-11-02",
      "2020-11-15",
      "2020-11-20",
      "2020-12-24",
      "2020-12-25",
      "2020-12-31",
      "2021-01-01",
      "2021-02-15",
      "2021-02-16",
      "2021-02-17",
      "2021-04-02",
    ],
    minDate: moment().add(0, "days").format("YYYY-MM-DD"),
    maxDate: moment().add(3, "months").format("YYYY-MM-DD"),
    grupos: collect([]),
    servicos: collect([]),
    polos: collect([]),
    horarios_disponiveis: collect([]),
    diasDisponiveis: [],
    data: null,
    pickerDate: null,
    hora: null,
    maskedCelular: "",
    maskedCpf: "",
    opcoesImovel:[
      {
        text : 'Matricula do imóvel',
        value : 'matricula_imovel'
      },
      {
        text : 'Inscrição municipal',
        value : 'inscricao_municipal'
      }
    ],
    informar_matricula_inscricao: false,
    form: {
      polo_id: null,
      grupoId: null,
      servico_id: null,
      data_hora: "",
      nome: "",
      celular: "",
      email: null,
      cpf: "",
      documentosImovel : [
        {
          opcaoImovel : "matricula_imovel",
          matricula_imovel : "",
          inscricao_municipal : ""
        }
      ]
    },
    rules: {
      inscricao: [
        (v) => !!v || /^\d+$/.test(v) || vm.$t("apenas-numeros"),
        (v) => v.length <= 10 || vm.$t("dez-caracteres"),
      ],
      matricula: [
        (v) => !!v || /^\d+$/.test(v) || vm.$t("apenas-numeros"),
        (v) => v.length <= 10 || vm.$t("dez-caracteres"),
      ],
      inscricao_matricula: [
        (v) => !!v || /^\d+$/.test(v) || vm.$t("apenas-numeros"),
        (v) => v.length <= 10 || vm.$t("dez-caracteres"),
        (v) => {if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) {return true;}}
      ],
      grupoId: [(v) => !!v || vm.$t("informe-um-grupo")],
      servico_id: [(v) => !!v || vm.$t("informe-um-servico")],
      polo_id: [(v) => !!v || vm.$t("informe-um-polo")],
      data: [(v) => !!v || vm.$t("informe-uma-data")],
      hora: [(v) => !!v || vm.$t("informe-uma-hora")],
      nome: [(v) => v.length > 0 || vm.$t("informe-um-nome")],
      celular: [
        (v) => !!v || vm.$t("informe-um-celular"),
        (v) => v.charAt(5) === "9" || vm.$t("informe-um-celular-valido"),
        (v) => v.length === 15 || vm.$t("informe-um-celular-valido"),
      ],
      email: [
        (v) => !v || /.+@.+\..+/.test(v) || vm.$t("informe-um-email-valido"),
      ],
      cpf: [
        (cpf) => !!cpf || vm.$t("informe-um-cpf"),
        (cpf) => {
          cpf = cpf.replace(/\D/g, "");
          if (cpf === "") {
            return true;
          }
          if (cpf.length > 1 && cpf.length != 11) {
            return vm.$t("informe-um-cpf-valido");
          }
          if (
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999"
          ) {
            return vm.$t("informe-um-cpf-valido");
          }
          let numero = 0;
          let caracter = "";
          let numeros = "0123456789";
          let j = 10;
          let somatorio = 0;
          let resto = 0;
          let digito1 = 0;
          let digito2 = 0;
          let cpfAux = "";
          cpfAux = cpf.substring(0, 9);
          for (let i = 0; i < 9; i++) {
            caracter = cpfAux.charAt(i);
            if (numeros.search(caracter) == -1) {
              return vm.$t("informe-um-cpf-valido");
            }
            numero = Number(caracter);
            somatorio = somatorio + numero * j;
            j--;
          }
          resto = somatorio % 11;
          digito1 = 11 - resto;
          if (digito1 > 9) {
            digito1 = 0;
          }
          j = 11;
          somatorio = 0;
          cpfAux = cpfAux + digito1;
          for (let i = 0; i < 10; i++) {
            caracter = cpfAux.charAt(i);
            numero = Number(caracter);
            somatorio = somatorio + numero * j;
            j--;
          }
          resto = somatorio % 11;
          digito2 = 11 - resto;
          if (digito2 > 9) {
            digito2 = 0;
          }
          cpfAux = cpfAux + digito2;
          if (cpf != cpfAux) {
            return vm.$t("informe-um-cpf-valido");
          } else {
            return true;
          }
        },
      ],
    },
  }),
  methods: {
    async fetchAll() {
      this.showOverlay = true;
      Promise.all([
        GrupoServicoRepository.listar().then((response) => {
          this.grupos = response;
        }),
        ServicoRepository.listar().then((response) => {
          this.servicos = response;
        }),
        PoloRepository.listar().then((response) => {
          this.polos = response;
        }),
      ])
        .catch(() => {
          this.$swal({
            html: this.$t("erro-resgate-servicos"),
            icon: "error",
          });
        })
        .then(() => {
          this.showOverlay = false;
        });
    },
    async fetchServicos() {
      this.showOverlay = true;
      try {
        this.servicos = await ServicoRepository.listar({
          grupoId: this.form.grupoId,
        });
        if (
          !this.servicos.first((servico) => servico.id === this.form.servico_id)
        ) {
          this.form.servico_id = null;
        }
        this.data = "";
      } catch (error) {
        this.form.servico_id = null;
        this.$swal({
          html: this.$t("erro-resgate-servicos"),
          icon: "error",
        });
      }
      this.showOverlay = false;
    },
    async fetchPolos() {
      this.showOverlay = true;
      try {
        this.polos = await PoloRepository.listar({
          servico_id: this.form.servico_id,
        });
        if (!this.polos.firstWhere("polo_id", this.form.polo_id)) {
          this.form.polo_id = null;
        }
        this.data = "";
      } catch (error) {
        this.$swal({
          html: this.$t("erro-resgate-polos"),
          icon: "error",
        });
      }
      this.showOverlay = false;
    },
    async fetchHorariosDisponiveis() {
      if (
        this.form.polo_id !== null &&
        this.form.servico_id !== null &&
        this.data !== null &&
        this.data !== ""
      ) {
        this.showOverlay = true;
        try {
          this.horarios_disponiveis =
            await AgendamentoRepository.horarios_disponiveis(
              this.form.polo_id,
              this.form.servico_id,
              this.data
            );
        } catch (error) {
          this.horarios_disponiveis = collect([]);
          this.hora = null;
          this.$swal({
            html: this.$t("erro-resgate-horarios"),
            icon: "error",
          });
        }
        this.showOverlay = false;
      }
    },
    async getDiasDisponiveis(polo_id, servico_id, data_inicio, data_fim) {
      return new Promise((resolve, reject) => {
        AgendamentoRepository.getDiasDisponiveis(
          polo_id,
          servico_id,
          data_inicio,
          data_fim
        ).then(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    async submitAgendamento() {
      if (!this.sendindForm) {
        this.sendindForm = true;
        this.showOverlay = true;

        if (
          this.informar_matricula_inscricao &&
          !this.form.documentosImovel.length > 1) {
          this.$swal({
            html: "Deve ser informado Matrícula do imóvel e/ou inscrição municipal",
            icon: "error",
          });
          this.showOverlay = false;
          this.sendindForm = false;
          return;
        }

        const polo = this.polos.firstWhere("polo_id", this.form.polo_id) || "";
        const servico =
          this.servicos.firstWhere("id", this.form.servico_id) || "";

        this.$store.state.servico = servico.nome || "";
        this.$store.state.polo = polo.polo_nome || "";
        this.$store.state.endereco = this.getFullAddress(
          polo.endereco_polo_logradouro,
          polo.endereco_polo_numero,
          polo.endereco_polo_complemento,
          polo.endereco_polo_bairro,
          polo.ponto_referencia
        );

        this.$store.state.matricula_imovel = this.form.matricula;
        this.$store.state.inscricao_municipal = this.form.inscricaoMunicipal;

        let hora = this.horarios_disponiveis.firstWhere(
          "hora_agendado",
          this.hora
        );
        this.$store.state.horario = `${moment(this.data).format(
          "DD/MM/YYYY"
        )} às ${hora.hora_local}`;
        try {
          let response = await AgendamentoRepository.cadastrar(this.form);
          this.$store.state.protocolo = response.protocolo;
          this.$store.state.showModaAgendamentolSucesso = true;
        } catch (error) {
          if (error == 409) {
            this.$swal({
              html: this.$t("erro-horario-agendado"),
              icon: "warning",
            });
          } else if (error == 412) {
            this.$swal({
              html: this.$t("erro-horario-agendado-cpf"),
              icon: "warning",
            });
          } else {
            this.$swal({
              html: this.$t("erro-cadastro"),
              icon: "error",
            });
          }
        }
        this.showOverlay = false;
        this.sendindForm = false;
        if (this.$store.state.showModaAgendamentolSucesso) {
          this.$router.push("/");
        }
      }
    },
    onInputCelular(event) {
      let maskedValue = event.target.value;
      let unmaskedValue = maskedValue.replace(/\D/g, "");
      unmaskedValue = unmaskedValue.substring(0, 11);
      maskedValue = VMasker.toPattern(unmaskedValue, "(99) 99999-9999");
      this.maskedCelular = maskedValue;
      this.form.celular = unmaskedValue;
    },
    onInputCpf(event) {
      let maskedValue = event.target.value;
      let unmaskedValue = maskedValue.replace(/\D/g, "");
      unmaskedValue = unmaskedValue.substring(0, 11);
      maskedValue = VMasker.toPattern(unmaskedValue, "999.999.999-99");
      this.maskedCpf = maskedValue;
      this.form.cpf = unmaskedValue;
    },
    allowedDates(date) {
      if (this.isDateValid(date)) {
        return true;
      } else {
        return false;
      }
    },
    isDateValid(date) {
      let week_number = moment(date).isoWeekday();
      if (!this.diasDisponiveis.includes(date)) {
        return false;
      } else if (week_number === 6 && week_number === 7) {
        return false;
      } else if (this.notAllowedDates.includes(date)) {
        return false;
      } else if (this.isDateBeforeNow(date)) {
        return false;
      } else {
        return true;
      }
    },
    isDateBeforeNow(date) {
      const nowDate = moment().format("YYYY-MM-DD");
      const datePicker = moment(date).format("YYYY-MM-DD");
      return moment(datePicker).isBefore(nowDate);
    },
    setDateRange(minDate, maxDate) {
      this.minDate = minDate
        ? moment(minDate).format("YYYY-MM-DD")
        : moment().add(0, "days").format("YYYY-MM-DD");
      this.maxDate = maxDate
        ? moment(maxDate).format("YYYY-MM-DD")
        : moment().add(3, "months").format("YYYY-MM-DD");
    },
    toggleDatePicker(value) {
      this.isDatePickerEnabled = value;
    },
    getFirstAndLastDay(date) {
      let firstDay;
      if (moment(date).isSame(moment().format("YYYY-MM"))) {
        firstDay = moment().format("YYYY-MM-DD");
      } else {
        firstDay = moment(date).startOf("month").format("YYYY-MM-DD");
      }
      const lastDay = moment(date).endOf("month").format("YYYY-MM-DD");
      return { firstDay: firstDay, lastDay: lastDay };
    },
    async reloadDiasDisponiveis(date) {
      this.showOverlay = true;
      let days;
      if (date) {
        days = this.getFirstAndLastDay(moment(date).format("YYYY-MM"));
      } else {
        this.pickerDate = moment().format("YYYY-MM");
        days = this.getFirstAndLastDay(moment().format("YYYY-MM"));
      }

      this.diasDisponiveis = await this.getDiasDisponiveis(
        this.form.polo_id,
        this.form.servico_id,
        days.firstDay,
        days.lastDay
      );
      this.showOverlay = false;
    },
    addFields(){
      if(this.form.documentosImovel.length <= 4){
        this.form.documentosImovel.push({
          opcaoImovel : "matricula_imovel",
          inscricao_municipal : "",
          matricula_imovel : ""
       });
      } 
    },
    removeField(item){
      if(this.form.documentosImovel.length > 1){
        this.form.documentosImovel.splice(this.form.documentosImovel.indexOf(item),1)
      }
    }
  },
  watch: {
    form: {
      handler: function (val) {
        if (val.polo_id && val.grupoId && val.servico_id) {
          this.toggleDatePicker(true);
        } else {
          this.toggleDatePicker(false);
        }
      },
      deep: true,
    },
    async pickerDate(val) {
      this.reloadDiasDisponiveis(val);
    },
  },
  computed: {
    locale_code: () => process.env.VUE_APP_I18N_LOCALE,
  },
  mixins: [addressMixin],
})
export default class ServicosOnline extends Vue {
  beforeCreate() {
    this.$store.state.title = "Agendamento Online";
  }

  created() {
    this.fetchAll();
  }
  @Watch("form.grupoId")
  onGrupoChanged(val, oldVal) {
    if (val !== oldVal) {
      this.fetchServicos(val);
      this.fetchHorariosDisponiveis();
      this.isDatePickerEnabled ? this.reloadDiasDisponiveis(false) : "";
    }
  }
  @Watch("form.servico_id")
  onServicoChanged(val, oldVal) {
    if (val !== oldVal) {
      const servico = this.servicos.firstWhere("id", val);
      this.informar_matricula_inscricao =
        servico.informar_matricula_ou_inscricao;
      val
        ? this.setDateRange(servico.periodo_inicial, servico.periodo_fim)
        : "";
      this.fetchPolos(val);
      this.fetchHorariosDisponiveis();
      this.isDatePickerEnabled ? this.reloadDiasDisponiveis(false) : "";
    }
  }

  @Watch("form.polo_id")
  onPoloChanged(val, oldVal) {
    if (val !== oldVal) {
      this.fetchHorariosDisponiveis();
      this.isDatePickerEnabled ? this.reloadDiasDisponiveis(false) : "";
    }
  }

  @Watch("data")
  onDataChanged(val) {
    if (val) {
      this.hora = null;
      this.fetchHorariosDisponiveis();
    }
  }

  @Watch("hora")
  onHoraChanged(val) {
    if (val) {
      this.form.data_hora = `${this.data} ${val}`;
    } else {
      this.form.data_hora = null;
    }
  }

  @Watch("form.email")
  onEmailChanged(val) {
    if (val === "") this.form.email = null;
  }

  @Watch("form.cpf")
  onCpfChanged(val) {
    if (val === "") this.form.cpf = null;
  }
}
</script>